import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./MemberDetails.css";

const MemberDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const student = state?.student;

  if (!student) {
    return (
      <div className="memberDetailsPage">
        No Data Found
      </div>
    );
  }

  return (
    <div className="memberDetailsPage">

      <div className="topBar">
        <button
          className="backBtn"
          onClick={() => navigate(-1)}
        >
          ←
        </button>

        <h2>Member Details</h2>
      </div>

      <div className="profileCard">

        <div className="profileAvatar">
          {student.childname?.charAt(0)}
        </div>

        <h3>{student.childname}</h3>

        <p>{student.parentname}</p>

      </div>

      <div className="detailsCard">

        <div className="detailRow">
          <span>ID</span>
          <strong>{student.st_id}</strong>
        </div>

        <div className="detailRow">
          <span>Primary No</span>
          <strong>{student.primary_no}</strong>
        </div>

        <div className="detailRow">
          <span>Alternate No</span>
          <strong>{student.alternate_no}</strong>
        </div>

        <div className="detailRow">
          <span>Address</span>
          <strong>{student.address}</strong>
        </div>

        <div className="detailRow">
          <span>Pincode</span>
          <strong>{student.pincode}</strong>
        </div>

        <div className="detailRow">
          <span>Joining Date</span>
          <strong>{student.joining_date}</strong>
        </div>

        <div className="detailRow">
          <span>Group</span>
          <strong>{student.group_code}</strong>
        </div>

      </div>

      <div className="detailsCard">

        <h4>Fees Information</h4>

        <div className="detailRow">
          <span>Fees Type</span>
          <strong>{student.fees_type}</strong>
        </div>

        <div className="detailRow">
          <span>Total Fees</span>
          <strong>₹{student.total_fees}</strong>
        </div>

        <div className="detailRow">
          <span>Fees Amount</span>
          <strong>₹{student.fees_amount}</strong>
        </div>

        <div className="detailRow">
          <span>Cab Stop</span>
          <strong>{student.stop_location}</strong>
        </div>

        <div className="detailRow">
          <span>Cab Monthly</span>
          <strong>
            ₹{student.cab_monthly_amount}
          </strong>
        </div>

      </div>

    </div>
  );
};

export default MemberDetails;